import { PaymentDto } from '@up/data';

export class FireOpenPaymentResponse {
  message?: string;
  success: boolean;
  payment?: PaymentDto;
  code?: string;
}
